import { FORMATTER_EXAMPLES } from "./formatterExamples.js";
import { FORMATTER_ROUTE_EXAMPLES } from "./formatterRouteExamples.js";
const allEntries = [...FORMATTER_EXAMPLES, ...FORMATTER_ROUTE_EXAMPLES];
const uniqueBySlug = new Map();
for (const entry of allEntries) {
    if (!uniqueBySlug.has(entry.slug)) {
        uniqueBySlug.set(entry.slug, entry);
    }
}
export const ALL_FORMAT_SLUG_EXAMPLES = Array.from(uniqueBySlug.values());
